import { MAX_ITEM_QUANTITY } from "../../shop/cartStore";

function QuantityStepper({ value, onChange, t, min = 1, size = "md" }) {
  return (
    <div className={`qty-stepper qty-stepper--${size}`} role="group" aria-label={t.quantity}>
      <button
        type="button"
        onClick={() => onChange(value - 1)}
        disabled={value <= min}
        aria-label={t.decrease}
      >
        −
      </button>
      <output aria-live="polite">{value}</output>
      <button
        type="button"
        onClick={() => onChange(value + 1)}
        disabled={value >= MAX_ITEM_QUANTITY}
        aria-label={t.increase}
      >
        +
      </button>
    </div>
  );
}

export default QuantityStepper;
